import { render } from "./PersonSummary.vue?vue&type=template&id=412b4919&scoped=true"
import script from "./PersonSummary.vue?vue&type=script&lang=js"
export * from "./PersonSummary.vue?vue&type=script&lang=js"

import "./PersonSummary.vue?vue&type=style&index=0&id=412b4919&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3522\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412b4919"]])

export default __exports__